module.exports = __webpack_public_path__ + "static/media/service_body_03.70a7a62d.webp";